export default {
  "content": "<circle cx=\"16\" cy=\"16\" r=\"16\" fill=\"#CFF5D4\"/><path d=\"M7.51 10.665l8.175-3.615a.62.62 0 01.487 0l8.32 3.615m-16.983.09v2.144h16.983v-2.145M9.835 13.162v6.881m4.112-6.88v6.88m4.112-6.88v6.88m4.111-6.88v6.88m-14.66.186h16.983v2.145H7.508V20.23z\" stroke=\"#1D1D1B\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "width": "32",
    "height": "32",
    "viewBox": "0 0 32 32",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};